<!-- Come sta andando -->
<!-- <mat-card class="content mb-3" *ngIf="profileData"> -->
<mat-card class="content mb-3">
    <mat-card-header class="pb-2 d-flex justify-content-between header-title">
        <mat-card-title class="main-font card-title">Riepilogo</mat-card-title>

        <!-- <button *ngIf="!isUser && data?.competenze?.is_completed" [ngStyle]="{'color': isAuthorized ? 'white' : 'primary'}" mat-mini-fab color="primary" [matTooltip]="isAuthorized ? 'Hai eseguto la review' : 'Review ricevuta' " matTooltipPosition="left">
            <mat-icon class="icon-btn bg">done</mat-icon>
        </button> -->

        <button id="id_badge" class="me-3" *ngIf="is_hidden == false && isAuthorized
          && data?.competenze.is_completed == false && (reviewData?.is_partial_completed || reviewData?.is_draft)"
            [ngStyle]="{'background-color': reviewData?.is_partial_completed  ? 'orange' :  this.reviewData.is_draft == true ? 'white' : 'black' , 'color': reviewData?.is_partial_completed
          && this.reviewData.is_draft == false ? 'white' : 'black'}"
            [matTooltip]="reviewData?.is_partial_completed  ? 'Eseguita da ' + reviewData.users_reviewer.first_name + ' ' + reviewData.users_reviewer.first_name : 'Bozza'"
            mat-mini-fab>
            <mat-icon class="icon-btn bg">done</mat-icon>
        </button>
    </mat-card-header>


    <mat-card-content>
        <mat-tab-group>
            <mat-tab class="main-font" label="Andamento" style="padding: 0px!important;">
                <form [formGroup]="HowIsGoingForm">
                    <div>
                        <mat-form-field class="w-100" color="accent" appearance="fill">
                            <textarea
                                [placeholder]="isUserEmployedLessThanOneMonth() && !isAuthorized ? 'Questa sezione sarà disponibile un mese dopo l\'inizio del rapporto di lavoro.' : '' "
                                matInput rows="10"
                                [readonly]="!isUser || this.currentMonth != data?.current_month || this.review != null && data?.competenze.is_completed != false || isUserEmployedLessThanOneMonth()"
                                formControlName="how_is_going" (keypress)="onEdit()"></textarea>
                        </mat-form-field>
                    </div>
                    <div class="submit d-flex justify-content-end"
                        *ngIf="this.currentMonth == data?.current_month  && edit == true ">
                        <button *ngIf="isUserEmployedLessThanOneMonth() == false" mat-raised-button color="accent"
                            (click)="(reviewData != undefined) ? updateHowIsGoing() : addHowIsGoing()">Salva</button>
                    </div>
                </form>
            </mat-tab>
            <mat-tab label="Review">
                <form [formGroup]="ReviewForm">
                    <div>
                        <mat-form-field class="w-100" color="accent" appearance="fill">
                            <textarea matInput rows="10"
                                [readonly]="!isAuthorized || this.reviewData == null || this.currentMonth != data?.current_month || is_completed"
                                formControlName="review" (keydown)="onEdit()"></textarea>
                        </mat-form-field>
                    </div>
                    <div class="submit d-flex justify-content-end"
                        *ngIf="isAuthorized && this.currentMonth == data?.current_month  && edit == true ">
                        <!-- <button mat-raised-button color="accent" (click)="(reviewData != undefined) ? updateReview() : addReview()">Salva</button> -->
                        <button class="me-1" type="submit" mat-raised-button color="accent"
                            (click)=" resetPartialReview()">{{isAuthorized ? 'Salva Bozza': 'Salva Modifiche'}}
                        </button>
                        <button type="submit" mat-raised-button color="accent" (click)="sendPartialReview()">{{'Salva
                            riepilogo'}}</button> <!-- (click)="changeState()" -->

                    </div>
                </form>
            </mat-tab>
        </mat-tab-group>
    </mat-card-content>
</mat-card>